module.exports = __webpack_public_path__ + "static/media/CeraPro-Bold.00199a27.ttf";